import { render, staticRenderFns } from "./BotaoAnterior.vue?vue&type=template&id=513c6a90&"
import script from "./BotaoAnterior.vue?vue&type=script&lang=js&"
export * from "./BotaoAnterior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports